// External destinations referenced from CTAs and footer links.
// Adjust here once and every CTA picks it up.
export const LINKS = {
  setup: "https://cal.com/stephanie-sistilli/sidestack-setup",
  contact: "https://cal.com/stephanie-sistilli/sidestack-setup",
  x: "https://x.com/try_sidestack",
  trust:
    "https://docs.google.com/document/d/1sWHRWvhPn036lIB1u5E35YKw4hWSvbbs9Hbn6HTnriQ/edit?usp=sharing",
  terms: "/terms.html",
  privacy: "/privacy.html",
} as const;
